import { Auth } from 'aws-amplify';

export const authenticate = async () => {
  try {
    const response = await Auth.currentAuthenticatedUser({
      bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

export const signup = async ({ email, password, fullName }) => {
  try {
    const response = await Auth.signUp({
      username: email,
      password,
      attributes: {
        email,
        name: fullName,
        'custom:team': 'unassigned',
      },
    });
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

export const login = async ({ email, password }) => {
  try {
    // Auth.signIn doesn't return the updated user attributes if a valid session exists
    await Auth.signIn({
      username: email,
      password,
    });
    // gets the current user with the latest user attributes
    const currentAuthenticatedUser = await Auth.currentAuthenticatedUser({
      bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });

    return { data: currentAuthenticatedUser };
  } catch (err) {
    return { error: err.message };
  }
};

export const logout = async () => {
  try {
    const response = Auth.signOut();
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

// Send confirmation code to user's email
export const forgotPassword = async ({ email }) => {
  try {
    const response = await Auth.forgotPassword(email);
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

// Collect confirmation code and new password, then
export const forgotPasswordSubmit = async ({ email, code, newPassword }) => {
  try {
    const response = await Auth.forgotPasswordSubmit(
      email,
      String(code),
      newPassword,
    );
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

export const resendSignUp = async ({ email }) => {
  try {
    const response = await Auth.resendSignUp(email);
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};
